document.addEventListener('DOMContentLoaded', function () {
  const closeSearch = () => {
    document.querySelectorAll('predictive-search-component').forEach(component => {
      component.classList.remove('predictive-search--expanded');
    });
  };

  document.addEventListener('click', (event) => {
    document.querySelectorAll('predictive-search-component').forEach(component => {
      if (!component.contains(event.target)) {
        component.classList.remove('predictive-search--expanded');
      }
    });
  });

  document.addEventListener('scroll', () => {
    closeSearch();
  }, { passive: true });
});